<template>
  <div>
    <div style="margin-bottom:20px;">
      <template v-for="item in chartsData">
        <bar :chartsData="item" :key="item.key"></bar>
      </template>
    </div>
    <!--table--->
    <table-view
      :columns="columns"
      :pagination="false"
      :data="tableData"
      :loading="loading"
      :scroll="scroll"
      rowKey="key"
    >
      <!--name slot-->
      <template v-slot:customName="">
        <span>{{ tab }}</span>
      </template>
      <!--current slot-->
      <template v-slot:current="{ tableRow }">
        <span>{{ tableRow.current.value | formatAmount }}</span>
      </template>
      <!--current slot-->
      <template v-slot:currentAvg="{ tableRow }">
        <span>{{ tableRow.currentAvg | formatAmount }}</span>
      </template>
      <!--prev slot-->
      <template v-slot:prev="{ tableRow }">
        <span>{{ tableRow.prev.value | formatAmount }}</span>
      </template>
      <!--prevAvg slot-->
      <template v-slot:prevAvg="{ tableRow }">
        <span>{{ tableRow.prevAvg | formatAmount }}</span>
      </template>
      <!--beforePrev slot-->
      <template v-slot:beforePrev="{ tableRow }">
        <span>{{ tableRow.beforePrev.value | formatAmount }}</span>
      </template>
      <!--beforePrevAvg slot-->
      <template v-slot:beforePrevAvg="{ tableRow }">
        <span>{{ tableRow.beforePrevAvg | formatAmount }}</span>
      </template>
      <!--操作 slot-->
      <template v-slot:action="{ tableRow }">
        <a-button
          size="small"
          :type="tableRow.flag == true ? 'danger' : 'primary'"
          @click="showHandle(tableRow, chartsData, tableData)"
        >
          {{ tableRow.flag == true ? '关闭图表' : '显示图案' }}
        </a-button>
        <template
          v-if="
            permissions &&
              permissions['财务分析'] &&
              permissions['财务分析'].includes('编辑')
          "
        >
          <a-divider type="vertical" />
          <a-button
            size="small"
            type="primary"
            @click="
              $refs.dataEdit.add(tableRow, form.year, chartsData, tableData)
            "
          >
            数据编辑
          </a-button>
        </template>
      </template>
    </table-view>
    <data-edit ref="dataEdit" @getTableData="_getTableData"></data-edit>
  </div>
</template>
<script>
import mixin from './mixin'
import { TableView } from 'lxfintech-fe'
import Bar from './Bar'
import DataEdit from './DataEdit'
import { getChart } from '../api'
import { mapGetters } from 'vuex'
export default {
  mixins: [mixin],
  props: ['chartsData', 'tableData', 'form', 'tab'],
  components: { TableView, Bar, DataEdit },
  data() {
    return {
      scroll: { x: 1200 }, //滚动设置
      loading: false,
      subData: {},
    }
  },
  computed: {
    ...mapGetters('app', ['permissions']),
  },
  methods: {
    async showHandle(row, chartData, tableData) {
      try {
        let flag = row.flag
        if (!flag) {
          if (chartData.length == 3) {
            this.$message.warning('请关闭某个图表再次打开')
          } else {
            tableData.forEach(item => {
              if (item.key === row.key) {
                item.flag = true
              }
            })
            this.subData = {
              ...this.form,
              name: row.key,
            }
            const { data } = await getChart(this.subData)
            chartData.push(data)
            this.$emit('renderItem', chartData, tableData)
          }
        } else {
          let key = row.key
          chartData.splice(
            chartData.findIndex(item => item.key === key),
            1,
          )
          tableData.forEach(item => {
            if (item.key === key) {
              item.flag = false
            }
          })
          this.$nextTick(() => {
            this.$emit('renderItem', chartData, tableData)
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    _getTableData() {
      this.$emit('getTableData')
    },
  },
}
</script>
